import ThumnailVideoComponent from "../../../commons/components/Video/thumbnailVideo";

type Props = {
  videoDetail: Object,
  params: Object
};

const VideoAllTab = ({ videoDetail, params }: Props) => {
  return(
    <div className="video-all-tab">
      <ThumnailVideoComponent videoDetail={videoDetail} location={params.type} publishStatus={true} classStyle={`album-page__photo-selector`}/>
      <div className="album-page__notice-text d-flex align-items-center">
        <p className="album-page__notice-text-content">
          {videoDetail?.video_message?.title ?? ''}
        </p>
      </div>
    </div>
  )
}

VideoAllTab.defaultProps = {
  src: "",
  title: "title",
};
export default VideoAllTab;
